// 시공사례 액션(rpc) — 현장 상세의 시공사례 초안 만들기.
import { rpc } from "@/api/client";

export const createPortfolioFromProject = (projectId: string) => rpc("portfolio/actions/createPortfolioFromProject", projectId);

export const createPortfolio = (form: FormData) => rpc("portfolio/actions/createPortfolio", form);

export const updatePortfolio = (portfolioId: string, form: FormData) => rpc("portfolio/actions/updatePortfolio", portfolioId, form);

export const deletePortfolio = (portfolioId: string) => rpc("portfolio/actions/deletePortfolio", portfolioId);

export const reorderPortfolios = (ids: string[], expected: string[]) => rpc("portfolio/actions/reorderPortfolios", ids, expected);
